// extracted by css-extract-rspack-plugin
var _1 = "yX5GsG9jV2xxojG01pzn3A--";
var _2 = "c9lsnrXQV36nvMenM69Rrg--";
export { _1 as "titleRow", _2 as "wrapper" }
